import React from "react";
import "./styles/loader.css"; // Create this CSS file for styling
import logo from './styles/images/mainlogo-loader.png';
import dark_logo from './styles/images/mainlogo-black.png';
const Loader = () => {
  return (
    <div className="loader-container">
      {/* <div className="loader"></div> */}
      <div class="center-body">
  <div class="loader-circle-9">
  <img src={logo} alt="a very dark logo to be Seen on the | Samah Home Care" width={'150px'} height={'150px'} />

    <span></span>
  </div>

</div>

</div>

  );
};

export default Loader;
